export default {
  MENU_ITEM_LOAD: 'MENU_ITEM_LOAD',
  MENU_ITEM_CREATE: 'MENU_ITEM_CREATE',
  MENU_ITEM_CREATE_BULK: 'MENU_ITEM_CREATE_BULK',
  MENU_ITEM_SAVE: 'MENU_ITEM_SAVE',
  MENU_ITEM_DELETE: 'MENU_ITEM_DELETE',
  MENU_ITEM_MENU_DELETE: 'MENU_ITEM_MENU_DELETE',
};


// WEBPACK FOOTER //
// ./modules/menu/constants/MenuItemConstants.js